<strong>Skupni potpisnici</strong>

<div nz-row>
  <div nz-col nzSpan="12">
    @if (fetchedDocument) {
    <div *ngFor="let cosigner of fetchedDocument.FromSigners">
      <p>
        <strong>
          <nz-icon [nzType]="cosigner.HasSigned ? 'check' : 'close'" nzTheme="outline"
            [ngStyle]="{ color: cosigner.HasSigned ? 'green' : 'red' }" style="font-size: 13px" />
        </strong>
        {{ cosigner.EntityName }} ({{ cosigner.KeyDisplay }})
      </p>
    </div>
    }
  </div>

  @if(fetchedDocument !=null && fetchedDocument.FromSigners != null && fetchedDocument.FromSigners.length > 0){
      <div nz-col nzSpan="12">
        <button class="mr-2" nz-button (click)="viewDocument()">
          <nz-icon nzType="file" nzTheme="outline" />
          Pregledaj dokument
        </button>
        <button nz-button class="mr-2" (click)="viewDocumentAttachments(fetchedDocument.AuthDocumentId)">
          <nz-icon nzType="paper-clip" nzTheme="outline" />
          Privitci
        </button>
        <button id="approveButton" class="mr-2" nz-button (click)="approveDocument(fetchedDocument.AuthDocumentId)">
          <nz-icon nzType="check" nzTheme="outline" />
          Odobri
        </button>

        <button nz-button nzDanger (click)="rejectDocument(fetchedDocument.AuthDocumentId)">
          <nz-icon nzType="close" nzTheme="outline" />
          Odbaci
        </button>
      </div>

      @if (fetchedDocument) {
    
          <div class="mt-2"
            nz-col
            nzSpan="18"></div>
                <div
            nz-col
            nzSpan="18"></div>
          <div
            nz-col
            nzSpan="6">
            @if (fetchedDocument.ForLegal?.EntityIzvorReg === 1) {
              <button
                nz-button
                (click)="openSudRegPopup(fetchedDocument.FromPersonLegal!.EntityOib!)">
                <nz-icon
                  nzType="search"
                  nzTheme="outline" />
                Provjera na sudskom registru
              </button>
            }
          </div>
      }


  }



  @else{
  <div nz-col nzSpan="10">
    <button class="mr-2" nz-button (click)="viewDocument()">
      <nz-icon nzType="file" nzTheme="outline" />
      Pregledaj dokument
    </button>
    <button nz-button class="mr-2" (click)="viewDocumentAttachments(fetchedDocument.AuthDocumentId)">
      <nz-icon nzType="paper-clip" nzTheme="outline" />
      Privitci
    </button>
    <button id="approveButton" class="mr-2" nz-button (click)="approveDocument(fetchedDocument.AuthDocumentId)">
      <nz-icon nzType="check" nzTheme="outline" />
      Odobri
    </button>

    <button class="mt-2" nz-button nzDanger (click)="rejectDocument(fetchedDocument.AuthDocumentId)">
      <nz-icon nzType="close" nzTheme="outline" />
      Odbaci
    </button>

    @if (fetchedDocument) {

    @if (fetchedDocument.ForLegal?.EntityIzvorReg === 1) {
    <button class="ml-2" nz-button (click)="openSudRegPopup(fetchedDocument.FromPersonLegal!.EntityOib!)">
      <nz-icon nzType="search" nzTheme="outline" />
      Provjera na sudskom registru
    </button>
    }

    }
  </div>
  }

</div>